<template>
	<div class="position-relative">
		<div class="authentication-wrapper authentication-basic container-p-y p-4 p-sm-0">
			<div class="authentication-inner py-6">
				<!-- Register Card -->
				<div class="card p-md-7 p-1">
					<!-- Logo -->
					<div class="app-brand justify-content-center mt-5">
						<a href="index.html" class="app-brand-link gap-2">
							<span class="app-brand-logo demo">
								<span style="color: var(--bs-primary)">
									<img src="@/assets/logo.png" style=" width: 160px;">
								</span>
							</span>
						</a>
					</div>
					<!-- /Logo -->
					<div class="card-body mt-1" v-if="company">
						<p class="mb-5 text-center">{{ $t('setupCompany.subtitle', { name: company.name }) }}</p>

						<form id="formAuthentication" @submit.prevent="saveCompanyData" class="mb-5">

							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control"
									id="companyName"
									name="companyName"
									:placeholder="$t('auth.register.companyPlaceholder')"
									v-model="form.companyName"
									@input="clearError('companyName')"
									autofocus />
								<label for="companyName">{{ $t('common.fields.companyName') }}</label>
								<small v-if="errors.companyName" class="text-danger">{{ errors.companyName }}</small>
							</div>

							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control"
									id="companyNumber"
									name="companyNumber"
									:placeholder="$t('setupCompany.sirenPlaceholder')"
									v-model="form.companyNumber"
									@input="clearError('companyNumber')"
									@blur="checkSiren"
									autofocus />
								<label for="companyNumber">{{ $t('common.fields.siren') }}</label>
								<small v-if="errors.companyNumber" class="text-danger">{{ errors.companyNumber }}</small>
							</div>

							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control"
									id="address"
									name="address"
									:placeholder="$t('setupCompany.addressPlaceholder')"
									v-model="form.address"
									@input="clearError('address')"
									autofocus />
								<label for="address">{{ $t('common.fields.address') }}</label>
								<small v-if="errors.address" class="text-danger">{{ errors.address }}</small>
							</div>

							<div class="form-floating form-floating-outline mb-5">
								<input
									type="text"
									class="form-control"
									id="vatNumber"
									name="vatNumber"
									:placeholder="$t('setupCompany.addressPlaceholder')"
									v-model="form.vatNumber"
									@input="clearError('vatNumber')"
									autofocus />
								<label for="vatNumber">{{ $t('common.fields.vatNumber') }}</label>
								<small v-if="errors.vatNumber" class="text-danger">{{ errors.vatNumber }}</small>
							</div>

							<button class="btn btn-primary d-grid w-100" @click="saveCompanyData()">{{ $t('common.actions.save') }}</button>
						</form>

						<p class="text-center">
							<span>{{ $t('setupCompany.doLater') }} </span>
							<router-link to="/">
								<span>{{ $t('common.actions.skip') }}</span>
							</router-link>
						</p>
					</div>
				</div>
				<!-- Register Card -->
				<img
					alt="mask"
					src="@/assets/img/illustrations/auth-basic-register-mask-light.png"
					class="authentication-image d-none d-lg-block"
					data-app-light-img="illustrations/auth-basic-register-mask-light.png"
					data-app-dark-img="illustrations/auth-basic-register-mask-dark.png" />
			</div>
		</div>
	</div>
</template>

<script>
import "@/assets/vendor/css/pages/page-auth.css";

import HTTP from "@/axios";

export default {
	name: "RegisterPage",

	data() {
		return {
			company: null,
			form: {
				companyName: "",
				companyNumber: "",
				address: "",
				vatNumber: ""
			},
			errors: {},
		};
	},

	async mounted() {
		try {
			const response = await HTTP('/company');

			this.company = response.data.company;

			this.form.address = this.company.address;
			this.form.companyNumber = this.company.companyNumber;
			this.form.vatNumber = this.company.vatNumber;
			this.form.companyName = this.company.name;
		} catch (error) {
			alert(this.$t('errors.cannotConnect'));
		}
	},

	methods: {
		checkSiren() {
			if (this.form.companyNumber.length < 9)
				return;

			this.fetchSirenData(this.form.companyNumber)
		},

		clearError(field) {
			// Supprime l'erreur pour le champ spécifié
			if (this.errors[field]) {
				delete this.errors[field];
			}
		},

		validateForm() {
			this.errors = {};

			if (!this.form.companyName) {
				this.errors.companyName = this.$t('validation.requiredCompanyName');
			}

			return Object.keys(this.errors).length === 0;
		},

		async fetchSirenData(siren) {
			try {
				const response = await HTTP(`/company/check-siren/${siren}`);

				this.form.companyName = response.data.companyName;
				this.form.address = response.data.formattedAddress;
				this.form.vatNumber = response.data.vatNumber;
			} catch (error) {
				console.error("Impossible de charger les données siren")
			}
		},

		async saveCompanyData() {
			const validated = this.validateForm();

			if (!validated)
				return;

			try {
				await HTTP.put('/company', this.form);
				this.$router.push("/");
			} catch (error) {
				alert(this.$t('errors.cannotCreateAccount'));
			}
		},
	}

};

</script>
